export const cleanLocalStorage = () => {
  localStorage.removeItem('balanceData')
  localStorage.removeItem('paymentForm')
  localStorage.removeItem('gcCampaign')
  localStorage.removeItem('giftcardForm')
}
